import { useOrderOverviewByIdQuery, useShippingAddressQuery } from 'api';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { ShippingInfo } from 'typings/client';
import { useCountryMapping } from 'hooks/useCountryMapping';

export const useGeneral = () => {
  const { id } = useParams() as { id: string };
  const { data = {} } = useOrderOverviewByIdQuery(id);
  const { countryMapping } = useCountryMapping();

  const { data: { data: clientShippingAddress = [] } = {} } = useShippingAddressQuery(
    { id: data.clientId },
    {
      skip: !data.clientId,
    }
  );

  const formattedShippingData = useMemo(
    () =>
      clientShippingAddress.map((_data: ShippingInfo): { label: string; value: string } => {
        const country = countryMapping[_data.countryId];
        const fullAddress = [country?.commonName, _data.streetAddress, _data.city, _data.state, _data.zip]
          .filter(Boolean)
          .join(', ');
        return {
          label: fullAddress,
          value: _data.id,
        };
      }),
    [clientShippingAddress, countryMapping]
  );
  return {
    data: {
      ...data,
      delivery: {
        ...data.delivery,
        deliveryAddress: formattedShippingData.find(
          (shippingData: any) => shippingData.value === data.delivery.shippingAddressId
        )?.label,
      },
    },
  };
};
